import { useEffect, useState } from 'react';
import ButtonDesigned from '../../../../components/UI-Elements/Buttons/ButtonDesigned';
import { OptionSelect } from '../../../../components/UI-Elements/Select/OptionSelect';
import { useGetAllRouteDetailsIds, useGetAllRouteIds, useRouteDetailById } from '../../../../hooks/useRouteById';
import { createRouteDetails, updateRouteDetail } from '../../../../sp-firebase/routeDetailsFB';
import { EditRouteDetails } from './EditRouteDetails/EditRouteDetails';
import { RouteDetails } from '../RouteDetails';
import { IRouteDetails } from '../../../../sp-types/routeDetailsType';

export const EditRouteDetailsScreen = () => {
  const { data: routeIds } = useGetAllRouteIds();
  const { data: routeDetailsIds } = useGetAllRouteDetailsIds();
  const [editedRouteId, setEditedRouteId] = useState('');
  const { data: routeData, isLoading, refetch } = useRouteDetailById(editedRouteId);
  const [currentRouteDetails, setRouteDetails] = useState<IRouteDetails>({ id: '', routeDetails: [] });
  const [isUpdatingRouteData, setIsUpdatingRouteData] = useState(false);

  useEffect(() => {
    if (routeData?.[0]) {
      setRouteDetails(routeData[0]);
    }
  }, [routeData]);

  const handleChangeRouteId = (routeId: string) => {
    routeDetailsIds?.includes(routeId) ? setEditedRouteId(routeId) : handleCreateNewRouteDetail(routeId);
  };

  const handleCreateNewRouteDetail = async (routeID: string) => {
    alert('route detail is missing , creating new route details');
    try {
      await createRouteDetails({ id: routeID, routeDetails: [] }, routeID), setEditedRouteId(routeID);
    } catch (error) {
      console.error('Error creating new route detail:', error); // Logs the error to the console

      alert('Error creating new route detail. try again');
    }
  };

  const handleUpdateRouteInDb = async (routeDetails: IRouteDetails) => {
    setIsUpdatingRouteData(true);
    await updateRouteDetail(routeDetails.id, routeDetails);
    await refetch();
    setIsUpdatingRouteData(false);
  };

  return (
    <div className="flex flex-col h-full  overflow-hidden gap-3">
      <div className="flex flex-row bg-white shadow-custom p-2 gap-3">
        <div className="">
          <OptionSelect
            subtitle="Edited Route :"
            options={routeIds || []}
            currentOption={editedRouteId}
            setCurrentOption={(value: string) => handleChangeRouteId(value)}
          />
        </div>
        <ButtonDesigned
          style="outline"
          isFunctionLoading={isLoading || isUpdatingRouteData}
          disableButton={isLoading || isUpdatingRouteData}
          onButtonClick={() => {
            handleUpdateRouteInDb(currentRouteDetails);
          }}
        >
          Update route details in Database
        </ButtonDesigned>
      </div>
      <div className="flex flex-1 flex-row gap-3 overflow-y-auto">
        <div className="bg-white w-[50rem] shadow-custom h-full px-6 py-10 space-y-4 overflow-y-auto ">
          <RouteDetails routeId={editedRouteId} />
        </div>
        <div className="bg-white w-[50rem] shadow-custom h-full px-6 py-10 space-y-4 overflow-auto">
          {currentRouteDetails.id && (
            <EditRouteDetails routeDetailsData={currentRouteDetails} setRouteDetails={setRouteDetails} />
          )}
        </div>
      </div>
    </div>
  );
};
